import React, { useState } from 'react';
import {
  handleStaticAsset,
  useStaticAsset,
} from '@leagueplatform/asset-config';
import {
  Box,
  GDSStyleObject,
  UtilityText,
  StackItem,
  useMediaQuery,
  queryHelpers,
} from '@leagueplatform/genesis-core';
import { useNavigateLegacy as useNavigate } from '@leagueplatform/routing';
import { SHARED_LIBRARY_ASSET_KEYS } from '../../types/shared-library.types';
import { SuccessModal } from './sucessModal';
import { ConfirmationModal } from './confirmationModal';
import { submitForm } from '../helpers/helpers';
import { NavigateBack } from './navigateBack';

export function FooterMultiStepProgress(props: any) {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const [isSuccessModal, setIsSuccessModal] = useState<boolean>(false);
  const {
    handleFormOrNext,
    isValidateForm,
    list,
    closeForm,
    formName,
    size,
    moduleName,
    isNextDisabled,
  } = props;
  const pointerSize = ['10px', '20px', '30px', '45px', '60px', '80px'];
  const pointerColorWidth = pointerSize[size];
  const navigate = useNavigate();
  const is355 = useMediaQuery(queryHelpers.between([300, 359]));
  const exact355 = useMediaQuery(queryHelpers.between([354, 356]));
  const getPosition = document.getElementById('jumpToTop');
  const totalPageCount = list.length;
  const goNext = () => {
    if (isNextDisabled) {
      return false;
    }
    if (handleFormOrNext) {
      if (selectedIndex !== list.length - 1) {
        setSelectedIndex(selectedIndex + 1);
        isValidateForm(false);
        getPosition?.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }
    } else {
      isValidateForm(true);
    }
    return true;
  };

  const goPrevious = () => {
    if (selectedIndex !== 0) {
      setSelectedIndex(selectedIndex - 1);
      getPosition?.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
    isValidateForm(false);
  };

  const navigateBack = () => {
    navigate(-1);
  };

  const handleFormSubmit = () => {
    if (handleFormOrNext) {
      submitForm(formName);
      setIsSuccessModal(true);
    } else {
      isValidateForm(true);
    }
  };

  const handleOnClickNext = (index: number) => {
    goNext();

    if (list[index]?.props?.trackAnalytics) {
      const analytics = list[index].props.trackAnalytics;
      analytics();
    }
  };

  const handleOnClickLast = (index: number) => {
    navigateBack();

    if (list[index]?.props?.trackAnalytics) {
      const analytics = list[index].props.trackAnalytics;
      analytics();
    }
  };

  const returnButton = () => {
    let returnButtonType;
    if (list[selectedIndex].props.lastPage) {
      returnButtonType = (
        <img
          onClick={() => handleOnClickLast(selectedIndex)}
          style={{ cursor: 'pointer' }}
          aria-hidden="true"
          src={
            handleStaticAsset(SHARED_LIBRARY_ASSET_KEYS.TICK_BUTTON) as string
          }
          alt="right arrow icon"
          width="40px"
        />
      );
    }
    if (!list[selectedIndex].props.lastPage) {
      returnButtonType = (
        <UtilityText
          css={{
            color: '#0074C9',
            cursor: 'pointer',
          }}
          onClick={handleFormSubmit}
        >
          Submit
        </UtilityText>
      );
    }
    return returnButtonType;
  };

  const rightArrowDisabledIcon = useStaticAsset(
    SHARED_LIBRARY_ASSET_KEYS.RIGHT_ARROW_DISABLED_ICON,
  );
  const rightArrowIcon = useStaticAsset(
    SHARED_LIBRARY_ASSET_KEYS.RIGHT_ARROW_ICON,
  );

  const checkResolution = () => {
    if (is355) {
      return '15px';
    }
    if (exact355) {
      return '0px';
    }
    return '15px';
  };

  return (
    <div
      style={{
        width: '100%',
        display: 'grid',
        placeItems: 'center',
      }}
    >
      {isSuccessModal ? (
        <SuccessModal onClose={closeForm} />
      ) : (
        <>
          {moduleName === 'navigateHistoryBack' ? (
            <NavigateBack />
          ) : (
            <ConfirmationModal />
          )}
          <Box
            id="jumpToTop"
            css={{
              display: 'flex',
              justifyContent: 'center',
              height: '75vh',
              overflowY: 'scroll',
              '@mobile': {
                overflowX: 'hidden',
                overflow: 'auto',
                width: '100%',
                scrollbarWidth: 'none',
                scrollBehavior: 'smooth',
                '&::-webkit-scrollbar': {
                  display: 'none',
                },
              },
            }}
          >
            {list[selectedIndex]}
          </Box>
          <Box
            css={{
              display: 'block',
              position: 'relative',
              backgroundColor: '#F8F8F8',
              '@mobile': {
                bottom: '80px',
                width: '100%',
              },
              '@media only screen and (width: 384px)': {
                bottom: '100px',
              },
            }}
          >
            <StackItem
              css={
                {
                  padding: '$none $two',
                  flexDirection: 'row',
                  marginTop: '$oneAndHalf',
                  justifyContent: 'center',
                } as GDSStyleObject
              }
            >
              {[...Array(totalPageCount)].map((i: any, index: any) => (
                <Box
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                  css={{
                    backgroundColor:
                      index >= selectedIndex + 1 ? '#D6D6D6' : '#0074C9',
                    width: pointerColorWidth,
                    height: '4px',
                    borderRadius: '$medium',
                    marginRight: '3px',
                    maxWidth: pointerColorWidth,
                  }}
                />
              ))}
            </StackItem>
            <Box
              css={
                {
                  display: 'flex',
                  flexDirection: 'row',
                  padding: '$two $one',
                  justifyContent: 'space-between',
                  width: '476px',
                  alignItems: 'center',
                  '@mobile': { width: 'auto' },
                } as GDSStyleObject
              }
            >
              <StackItem
                css={
                  {
                    '@mobile': {
                      marginLeft: is355 ? '0px' : '5px',
                      width: is355 ? '25px' : '25px',
                      maxWidth: '25px',
                    },
                  } as GDSStyleObject
                }
              >
                <img
                  onClick={selectedIndex + 1 > 1 ? goPrevious : () => {}}
                  style={{ cursor: selectedIndex + 1 > 1 ? 'pointer' : '' }}
                  src={
                    handleStaticAsset(
                      selectedIndex + 1 > 1
                        ? SHARED_LIBRARY_ASSET_KEYS.LEFT_ARROW_ICON
                        : SHARED_LIBRARY_ASSET_KEYS.LEFT_ARROW_DISABLED_ICON,
                    ) as string
                  }
                  alt="left arrow icon"
                  width="24px"
                  aria-hidden="true"
                />
              </StackItem>
              <StackItem
                css={
                  {
                    padding: '$none $five',
                    width: '205px',
                  } as GDSStyleObject
                }
              >
                <UtilityText emphasis="subtle">
                  {selectedIndex + 1} of {totalPageCount}
                </UtilityText>
              </StackItem>
              <StackItem
                css={
                  {
                    '@mobile': {
                      width: '25px',
                      // marginRight: is355 ? '15px' : '12px',
                      marginRight: checkResolution(),
                    },
                  } as GDSStyleObject
                }
              >
                {selectedIndex + 1 === totalPageCount ? (
                  returnButton()
                ) : (
                  <img
                    onClick={() => handleOnClickNext(selectedIndex)}
                    style={{ cursor: 'pointer' }}
                    aria-hidden="true"
                    src={
                      isNextDisabled
                        ? (rightArrowDisabledIcon as string)
                        : (rightArrowIcon as string)
                    }
                    alt="right arrow icon"
                    width="24px"
                  />
                )}
              </StackItem>
            </Box>
          </Box>
        </>
      )}
    </div>
  );
}
